export const TypeOfErrors = {
  MaxInsurancePriceExceeded: 'MaxInsurancePriceExceeded',
  ExternalFlightsError: 'ExternalFlightsError',
}
